module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-002sp-02 (カスタム) (1).f2464f34.jpg";